import React from "react"
import "./style.scss"

function HomeCoreValuesTimeline() {
  return (
    <div className="homeCoreValuesTimeline container d-flex flex-column justify-content-center align-items-center">
      <br />
      <div className="row my-5">
        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
          <div className="circleObject">
            <i
              className="flaticon-think fs-1 pt-2 text-white"
              style={{ opacity: 0.8 }}
            ></i>
          </div>
          <div className="display-3 text-purple mt-3">Innovate</div>
          <p className="fs-5">
            Exploring various cutting-edge technologies and standards to bring
            out the best suited tools and techniques for developing the most
            efficient software solution
          </p>
        </div>
      </div>
      <div className="verticleLine"></div>
      <div className="row my-5">
        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
          <div className="circleObject">
            <i
              className="flaticon-flask fs-1 pt-2 text-white"
              style={{ opacity: 0.8 }}
            ></i>
          </div>
          <div className="display-3 text-purple mt-3">Experiment</div>
          <p className="fs-5">
            Experiment with multiple solutions to come up with such a
            tailor-made solution, that will compete the market standards and
            scale as the data and users grow
          </p>
        </div>
      </div>
      <div className="verticleLine"></div>
      <div className="row my-5">
        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
          <div className="circleObject">
            <i
              className="flaticon-rocket fs-1 pt-2 text-white"
              style={{ opacity: 0.8 }}
            ></i>
          </div>
          <div className="display-3 text-purple mt-3">Deploy</div>
          <p className="fs-5">
            Using latest deployment environments including containerization,
            cloud native, etc. with continuous integration & continuous delivery
            with least possible down time to ensure that users get the best
            product experience
          </p>
        </div>
      </div>
    </div>
  )
}

export default HomeCoreValuesTimeline
